module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid18_1080x872.156b1d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid18_1080x872.jpg
// module id = 6I/Y
// module chunks = 0